module.exports = __webpack_public_path__ + "img/15600.9ad0a956.jpg";